import React from "react";
import styled from "styled-components/macro";
import { device, toRem } from "theme/Breakpoints";
import DesktopCartButton from "features/cart/DesktopCartButton";
import CompareButton from "./CompareButton";
import { Link, useNavigate } from "react-router-dom";
import Logo from "components/Logo/Logo";
import SearchBar from "features/searchBar/SearchBar";

export const upperMenus = [
  { title: "Галерия", route: "gallery" },
  { title: "Контакти", route: "contact-us" },
  { title: "За нас", route: "about-us" },
];

const TopSection = () => {
  return (
    <TopSectionContainer>
      <InnerContainer>
        <LogoWrapper>
          <Logo />
        </LogoWrapper>
        <SearchBar />
      </InnerContainer>
      <InnerContainer style={{ justifyContent: "flex-end" }}>
        {upperMenus.map((item, idx) => {
          return (
            <MenuLink key={idx} className="text-body" to={item.route} title={item.title} style={{ margin: "0 10px" }}>
              {item.title}
            </MenuLink>
          );
        })}
        <CompareButton />
        <DesktopCartButton />
      </InnerContainer>
    </TopSectionContainer>
  );
};
const LogoWrapper = styled.div`
  cursor: pointer;
  justify-content: flex-start;
  margin: 0 20px;
  @media only screen and (${device.laptop}) {
    width: ${toRem(120)};
    height: auto;
  }
  @media only screen and (${device.laptopL}) {
    width: ${toRem(180)};
    height: auto;
  }
`;
export const MenuLink = styled(Link)<{ fontSize?: number }>`
  cursor: pointer;
  text-decoration: none;
  color: white;
  &:hover {
    font-weight: 600;
  }

  &::before {
    display: block;
    content: attr(title);
    font-weight: 600;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
`;
const TopSectionContainer = styled.div`
  width: 100%;
  display: inline-flex;
  align-items: center;
  padding: 20px 0;
  justify-content: space-between;
  flex: 1;
`;

const InnerContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  width: 50%;
`;

export default TopSection;
